import { useEffect } from 'react';
import IDS from '../constants/IDS';
import CLASSNAMES from '../constants/CLASSNAMES';
import useTranslate from './useTranslate';
import type { IStateController } from '../lib/widget/state/state.interface';
import { useInjection } from 'inversify-react';
import { STATE_MODULE_IDS } from '../lib/widget/state/state.types';

const useError = () => {
  const { t } = useTranslate();
  const stateController: IStateController = useInjection(STATE_MODULE_IDS.STATE_CONTROLLER);
  const isNetworkError = stateController.state.errorType;
  const { errorMessage = t('eventNotFound') } = stateController.state;

  const reload = () => window.location.reload();

  useEffect(() => {
    const spinnerEl = document.getElementById(IDS.loadingSpinner);

    if (spinnerEl) {
      spinnerEl.classList.add(CLASSNAMES.HIDE);
    }
  }, []);

  return {
    isNetworkError,
    errorMessage,
    reload,
  };
};

export default useError;
